import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import { Form,Row, Col, Card} from 'react-bootstrap';
import {List,ListItem,ListItemText,Collapse, Switch} from '@material-ui/core';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import moment from 'moment';

class JadwalMapelForm extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading: false,
            jadwal: {},
            jadwalSubProfil: []
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() { 
        document.title = "Jadwal Mapel";
        this.getJadwalById();
        this.getJadwalSubProfil();        
    }

    getJadwalById = async() => {
        this.setState({ isLoading: true})
        const response = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_BY_ID + this.props.idJadwal)
        .catch (function(error){ alert(error) })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwal: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }        
    }

    getJadwalSubProfil = async() => {
        this.setState({ isLoading: true})
        const response = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_SUB_PROFIL + this.props.idJadwal +'/'+ this.props.idProfil)
        .catch (function(error){ alert(error) })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwalSubProfil: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }        
    }

    changeJadwalMulai = (value,id) => {   
        this.setState(prev => ({
            jadwalSubProfil: prev.jadwalSubProfil.map(item => item.idSubProfil === id ? { ...item, jadwalMulai: value } : item)
        }))
    }
    changeJadwalSelesai = (value,id) => {        
        this.setState(prev => ({
            jadwalSubProfil: prev.jadwalSubProfil.map(item => item.idSubProfil === id ? { ...item, jadwalSelesai: value } : item)
        }))
    }

    dateFormater(value) {        
        var dateObj = new Date(value);
        var momentObj = moment(dateObj);
        var momentString = momentObj.format('YYYY-MM-DD HH:mm:ss'); 
        return momentString;
    }


    handleSubmit = (e) => {
        e.preventDefault();
        const {jadwal,jadwalSubProfil} = this.state;         

        jadwalSubProfil.map(item => {
            item.idJadwal = jadwal.idJadwal;
            item.jadwalMulai = item.jadwalMulai === null ? jadwal.jadwalMulai : this.dateFormater(item.jadwalMulai);
            item.jadwalSelesai = item.jadwalSelesai === null ? jadwal.jadwalSelesai : this.dateFormater(item.jadwalSelesai);
        })

        this.props.submitJadwalSub(jadwalSubProfil, jadwal.idProfil)
        
    }

    render() { 
        const {jadwal,jadwalSubProfil} = this.state;        
        let pageTitle;        
        if(jadwalSubProfil.length !== 0) {
            pageTitle = 'Edit Jadwal Mapel'
        } else {
            pageTitle = 'Add Jadwal Mapel'
        }
        return ( 
            <>            
            <h4>{pageTitle} - {jadwal.namaJadwal}</h4>
            <br />
            {this.state.isLoading ? <Loader /> : 
            <Form onSubmit={this.handleSubmit}>
                {jadwalSubProfil.map((sub,i) =>    
                <Card style={{marginBottom:'5px'}} key={sub.idSubProfil}>
                    <Row>
                        <Col>
                            <ListItem>       
                                <span>{i+1}</span>                             
                                <ListItemText inset primary={sub.namaKategori} />    
                            </ListItem>
                        </Col>
                        <Col>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker 
                                value={sub.jadwalMulai === null ? jadwal.jadwalMulai : sub.jadwalMulai} 
                                onChange={(value, id) => this.changeJadwalMulai(value, sub.idSubProfil)}
                                name="jadwalMulai"
                                label="Jadwal Mulai"
                                onError={console.log}
                                ampm={false}
                                format="dd-MM-yyyy HH:mm"
                                minDate={jadwal.jadwalMulai}
                                maxDate={jadwal.jadwalSelesai} 
                            />
                            </MuiPickersUtilsProvider>                        
                        </Col>
                        <Col>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker                            
                                value={sub.jadwalSelesai === null ? jadwal.jadwalSelesai : sub.jadwalSelesai} 
                                onChange={(value, id) => this.changeJadwalSelesai(value, sub.idSubProfil)}
                                name="jadwalSelesai"                 
                                label="Jadwal Selesai"
                                onError={console.log}
                                ampm={false}
                                format="dd-MM-yyyy HH:mm"
                                minDate={jadwal.jadwalMulai} 
                                maxDate={jadwal.jadwalSelesai} 
                            />
                            </MuiPickersUtilsProvider>                        
                        </Col>
                    </Row>
                    <input type="hidden" name="idJadwal" value={jadwal.idJadwal} />
                    <input type="hidden" name="idSubProfil" value={sub.idSubProfil} />
                </Card>                
                )}

                <br />
                <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                
            </Form>
            }
            </>    
        );
    }

    handleBack() {
        this.props.handleBack(this.props.idProfil);
    }
}
 
export default JadwalMapelForm;